import { gql } from 'apollo-angular';
import { Tour } from 'src/app/tour-planning/shared/entities/tour';

export const TOUR_QUERY = gql`
query TourQuery($id: UUID)
{
  getTour: getTour(id: $id){
    id
    actualDepartureDateTime
  }
}
`;

export interface TourQueryResponse {
  getTour: Tour;
  loading: boolean;
}


